"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _createStyles.default;
  }
});

var _createStyles = _interopRequireDefault(require("./createStyles"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/createStyles/index.js
// module id = 995
// module chunks = 0